<template>
  <div v-if="article!==null" v-wechat-title="$route.meta.title" class="app-container">
    <div class="article-info">
      <div class="article-title">
        {{ article.title }}
      </div>
      <div class="article-author-info">
        <span class="publisher">
          <van-icon class-prefix="iconfont" name="person" />
          {{ article.publisherName }}
        </span>
        <span class="publish-time">
          <van-icon class-prefix="iconfont" name="clock" />
          {{ formatDateString(article.publishTime) }}
        </span>
        <span class="read-count">
          <van-icon class-prefix="iconfont" name="attention" size="18px" />
          {{ article.readCount }}
        </span>
      </div>
    </div>
    <article-content
      :content="article.content"
      @click-image="handleImageClick"
      @load-image="handleImageLoad"
    />
  </div>
</template>

<script>
import Vue from 'vue'
import { readArticle } from '@/api/article'
import { ArticleContent } from './components'
import { formatDate } from '@/utils'
import { Toast, ImagePreview } from 'vant'

Vue.use(ImagePreview)

export default {
  components: {
    ArticleContent
  },
  data() {
    return {
      article: null,
      images: []
    }
  },
  computed: {
    imageSources() {
      return this.images.map(image => {
        return image.src
      })
    }
  },
  created() {
    const id = this.$route.params.id || this.$route.query.id
    this.loadData(id)
  },
  mounted() {
    // 提示正在加载
    Toast.loading({
      message: '加载中...',
      duration: 0
    })
  },
  methods: {
    // 加载数据
    loadData(id) {
      readArticle(id).then(response => {
        // 清除提示
        Toast.clear()
        // 设置文章数据
        this.article = response.data
        // 设置浏览器标题
        this.$route.meta.title = this.article.title
      }).catch(error => {
        console.info(error)
        // 设置提示信息
        let message
        if (error.response && error.response.status === 404) {
          message = '未找到指定文章'
        } else {
          message = error.message
        }
        // 提示异常
        Toast.fail(message)
      })
    },
    // 格式化日期
    formatDateString(dateString) {
      return formatDate(new Date(dateString), 'yyyy-MM-dd')
    },
    handleImageClick(event) {
      // 图片预览
      ImagePreview({
        images: this.imageSources,
        startPosition: this.images.indexOf(event.target)
      })
    },
    handleImageLoad(event) {
      // 设置图片数组
      this.images.push(event.target)
    }
  }
}
</script>

<style scoped lang="scss">
.app-container {
  .article-info {
    padding: 10px;
    .article-title {
      font-size: 20px;
      font-weight: 700;
      line-height: 30px;
    }
    .article-author-info {
      color: #888;
      font-size: 12px;
      line-height: 22px;
      .publisher {
        .iconfont {
          vertical-align: -1px;
        }
      }
      .publish-time {
        margin-left: 10px;
        .iconfont {
          vertical-align: -1px;
        }
      }
      .read-count {
        float: right;
        .iconfont {
          vertical-align: -2px;
        }
      }
    }
  }
}
</style>
